import React, { useState } from "react";
import AlarmsWidget from "@/components/AlarmsWidget";

/**
 * AlarmsButton — small floating ⏰ button next to the orb that opens the
 * AlarmsWidget panel. Mirrors the EyesButton pattern so the dashboard
 * stays uncluttered until the owner needs the panel.
 */
export default function AlarmsButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="alarms-button"
        title="Manage wake-up alarms"
        className="fixed z-[30] pointer-events-auto"
        style={{
          right: "calc(50% - min(35vw, 280px) - 110px)",
          top: "calc(50% + 158px)",
          background: "rgba(0,0,0,0.65)",
          border: `1px solid ${open ? "var(--rc-gold)" : "var(--rc-gold-dim)"}`,
          color: "var(--rc-gold)",
          fontFamily: "'Share Tech Mono', monospace",
          fontSize: "10px",
          letterSpacing: "0.16em",
          padding: "10px 12px",
          backdropFilter: "blur(4px)",
          boxShadow: open ? "0 0 18px rgba(255,184,0,0.4)" : "0 0 10px rgba(255,184,0,0.2)",
          textTransform: "uppercase",
          cursor: "pointer",
        }}
      >
        <div style={{ fontSize: 18, marginBottom: 4, lineHeight: 1 }}>⏰</div>
        <div>ALARMS</div>
      </button>

      {open && (
        <div
          className="fixed z-[120] pointer-events-auto"
          data-testid="alarms-panel"
          style={{ right: 24, top: "calc(50% + 220px)", maxHeight: "60vh", overflow: "hidden" }}
        >
          <div style={{ position: "relative" }}>
            <button
              onClick={() => setOpen(false)}
              className="absolute top-2 right-2 text-[var(--rc-gold)] z-10"
              data-testid="alarms-close"
              style={{ fontSize: 16, lineHeight: 1 }}
            >✕</button>
            <AlarmsWidget />
          </div>
        </div>
      )}
    </>
  );
}
